// SP-2b — query-key factory for the self-scoped staff UI flags
// (stale-after-save convention: queryKey arrays live only in *Keys files).
// Stamping a flag invalidates the `all` prefix.

export const uiFlagsKeys = {
  all: ["ui-flags"] as const,
  list: () => ["ui-flags", "list"] as const,
};
